import { useTranslation } from 'react-i18next';
import Badge, { type BadgeVariant } from '@/components/base/Badge';
import type { LaundryModificationStatus } from '@/types';

const VARIANTS: Partial<Record<LaundryModificationStatus, BadgeVariant>> = {
  under_review: 'warning',
  approved: 'success',
  rejected: 'danger',
};

const ICONS: Partial<Record<LaundryModificationStatus, string>> = {
  under_review: 'ri-time-line',
  approved: 'ri-checkbox-circle-line',
  rejected: 'ri-close-circle-line',
};

interface ModificationStatusBadgeProps {
  status: LaundryModificationStatus;
}

/** Text + icon badge so status never relies on colour alone. */
export default function ModificationStatusBadge({ status }: ModificationStatusBadgeProps) {
  const { t } = useTranslation();
  if (status === 'none') return null;

  return (
    <Badge variant={VARIANTS[status] ?? 'neutral'} icon={ICONS[status]}>
      {t(`settings.mod.status.${status}`)}
    </Badge>
  );
}